export const dragDrop = () => {
  const $dropZone = document.querySelectorAll('[data-drop-files]');

  // Executa os eventos se existir container de Drag Drop
  if ($dropZone.length) {
    // Trigger pra usuario que clicar no container
    $dropZone.forEach(el => {
      el.addEventListener('click', () => clickHandler(el));
    });

    // Se o input for alterado, chama o montador de lista
    $dropZone.forEach(el => {
      el.querySelector('input').addEventListener('change', () => buildList(el.querySelector('input')));
    });

    // Chama o evento de Drop
    $dropZone.forEach(el => {
      el.addEventListener('drop', ev => handleDrop(ev, el), false);
    });

    // Chama Prevent Default para todos os eventos relacionados ao drag & drop
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      $dropZone.forEach(el => {
        el.addEventListener(eventName, preventDefaults, false);
      });
    });

    // Chama evento de highlight do container quando o usuário estiver com o mouse com itens acima do container
    ['dragenter', 'dragover'].forEach(eventName => {
      $dropZone.forEach(el => {
        el.addEventListener(eventName, () => highlight(el), false);
      });
    });

    // Remove o highlight quando o mouse sair de cima do container
    ['dragleave', 'drop'].forEach(eventName => {
      $dropZone.forEach(el => {
        el.addEventListener(eventName, () => unhighlight(el), false);
      });
    });
  }

  // Trigger de click
  function clickHandler(el) {
    el.querySelector('input').click();
  }

  // Impedir ação padrão do navegador
  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Adiciona a Classe Highlight ao container
  function highlight(el) {
    el.classList.add('highlight');
  }

  // Remove a Classe Highlight do container
  function unhighlight(el) {
    el.classList.remove('highlight');
  }

  // Função que equaliza o input file com os files dropados no container
  function handleDrop(ev, el) {
    let $input = el.querySelector('input');
    let dt = ev.dataTransfer;
    const transfer = new DataTransfer();

    // Loop dos arquivos dropados no container
    for (let file of dt.files) {
      let upload = true;

      // Verifica se o arquivo dropado não é maior que o aceitado pelo input em MB, attributo: (data-max-size).
      if ($input.hasAttribute('data-max-size')) {
        if (file.size >= $input.getAttribute('data-max-size') * 1000000) {
          upload = false;
        }
      }

      // Verifica se o arquivo dropado é de uma extensão aceita pelo input, atributo: (accept).
      if ($input.hasAttribute('accept')) {
        const accept = $input.getAttribute('accept');

        if (!accept.includes(file.type)) {
          upload = false;
        }
      }

      // Se o arquivo dropado passou pelas regras, é adicionado a lista de transferencia.
      if (upload) {
        transfer.items.add(file);
      }
    }

    // Adiciona os arquivos da lista de transferenia ao input file.
    $input.files = transfer.files;

    // Chama o montador de lista
    buildList($input);
  }

  // Função responsável por montar a listagem de items abaixo do container
  function buildList(input) {
    const $parent = input.closest('[data-drop-files]').parentNode;

    // define o elemento do titulo da lista
    const title = 'Lista de arquivos';
    const $h3 = document.createElement('h3');
    $h3.classList.add('c-list-documents__ttl');
    $h3.innerHTML = title;

    // define o elemento da lista
    const $list = document.createElement('div');
    $list.classList.add('c-list-documents');
    $list.setAttribute('data-uploaded', '');

    // Se o container já existe, remove ele
    let $toRemove = $parent.querySelector('[data-uploaded]');
    $toRemove && $toRemove.parentNode.removeChild($toRemove);

    // Monta o container
    $list.appendChild($h3);

    input.files.forEach((item, key) => {
      // define o elemento com o nome do arquivo
      const $name = document.createElement('span');
      $name.innerHTML = item.name;

      // define o botão de remover
      const $remove = document.createElement('span');
      $remove.classList.add('c-list-documents__remove');
      $remove.setAttribute('data-remove', key);

      // define o elemento de item da lista
      const $item = document.createElement('div');
      $item.classList.add('c-list-documents__item');
      $item.appendChild($name);
      $item.appendChild($remove);

      $list.appendChild($item);
    });

    $parent.appendChild($list);
  }

  document.addEventListener('click', function(e) {
    let el = e.target;

    // Se o botão de remover for clicado
    if (el.matches('[data-drop-container] span[data-remove]')) {
      const id = el.getAttribute('data-remove');
      const $container = el.closest('[data-drop-container]');
      const $input = $container.querySelector('input[type="file"]');

      // Salva a lista atual de files em um array
      let newFileList = Array.from($input.files);

      // Remove o item desejado
      newFileList.splice(id, 1);

      // Cria uma nova lista dataTransfer
      const transfer = new DataTransfer();
      for (let file of newFileList) {
        transfer.items.add(file);
      }

      // Associa a nova lista ao valor do input
      $input.files = transfer.files;

      // Chama a montagem da lista no html
      buildList($input);
    }
  });
};
